import * as api from '@/api'
import router from '@/router'
const state = {
  userInfo: {},
  // 其他用户信息
  roles: []
}

const mutations = {
  setToken: (state, token) => {
    state.token = token
  },
  setUserInfo: (state, userInfo) => {
    state.userInfo = userInfo
  },
  setRoles: (state, roles) => {
    state.roles = roles
  }
}

const actions = {
  // 模拟用户登录
  login({ commit }, userInfo) {
    return api.userLogin(userInfo).then((res) => {
      console.log('user_info', res.resData)
      commit('setUserInfo', res.resData)
      window.localStorage.setItem('setUserInfo', JSON.stringify(res.resData))
    })
  },
  logout({ commit }, userInfo) {
    return api.logout(userInfo).then((res) => {
      commit('setUserInfo', {})
      router.push('/login')
      console.log(res)
    })
  },
  // getInfo({ commit, state }) {
  //   return api.getInfo(state.token).then(({data: roles}) => {
  //     commit('setRoles', roles)
  //     return {roles}
  //   })
  // },
  resetToken({ commit }) {
    // 模拟清空令牌和角色状态
    return new Promise(resolve => {
      commit('setUserInfo', '')
      localStorage.removeItem('setUserInfo')
      resolve(1)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
actions}
